<div class="container" [class.back]="enableBackButton">
  <mnt-button-icon
    icon="arrow-left"
    variant="regular"
    color="neutral"
    size="medium"
    *ngIf="enableCloseButton"
    (buttonClick)="handleClose()"
  ></mnt-button-icon>
  <h3>{{ title }}</h3>
  <mnt-button-icon
    icon="close"
    variant="plain"
    color="neutral"
    size="medium"
    *ngIf="enableCloseButton"
    (buttonClick)="handleClose()"
  ></mnt-button-icon>
</div>